var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgArrowL2RWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img-arrow-l2r--white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30A4\\u30D9\\u30F3\\u30C8",
    transform: "translate(-320.000000, -2435.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(44.000000, 2420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(270.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,3 L13,5 L5,5 L5,13 L3,13 L3,3 L13,3 Z",
    id: "img-arrow-l2r--white",
    transform: "translate(8.000000, 8.000000) rotate(135.000000) translate(-8.000000, -8.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgArrowL2RWhite);
export default __webpack_public_path__ + "static/media/img-arrow-l2r--white.f197e6be492106a65d7445e91dd9694e.svg";
export { ForwardRef as ReactComponent };